import React, { Component } from 'react'
import AddressBlock from './AddressBlock'
import { RadioInput, TextInput } from './Form'
import { DumbField, FieldTooltip } from '../Field'
import { Result } from '../../ResultsDrawer/ResultsDrawer'
import Portal from 'components/Portal/Portal'
import { Modal } from '../../Modal/Modal'
import SearchControl from './SearchControl'
import PlusIcon from '@tecuity/sos-icons/react/plus-heavy'
import { buildFieldIdList, validateFieldArray } from 'components/Wizard2/WizardActions'
import { noop, FormattedAddress } from 'utilities'
import { getAddressObject, resolveAgentMailingAddress } from 'components/Wizard2/WizardClasses'
// import filter from 'lodash/filter';
// import ResultsDrawer from '../../ResultsDrawer/ResultsDrawer';

const RA_NONCOMMERCIAL_LABEL = process.env.RA_NONCOMMERCIAL_LABEL
const RA_ADDRESS_LABEL = process.env.RA_ADDRESS_LABEL

export default class RegisteredAgentSearch extends Component {
  constructor(props) {
    super()
    this.state = {
      search: '',
      modalOpen: false,
      results: {},
      filter: ''
    }
    this.searchRef = React.createRef()
  }
  componentDidMount = () => {
    if (this.props.isFirst && !this.props.disabled && this.focusTarget) {
      this.focusTarget.focus()
    }
  }
  onChange = (value, e) => {
    this.props.onChange({ ...this.props.value, [e.target.name]: value }, e)
  }
  setAddressValue = address => {
    this.props.onChange({ ...this.props.value, ...address }, {})
  }
  setMailAddressValue = address => {
    this.props.value.MAIL_ADDR = address
    this.props.onChange({ ...this.props.value }, {})
  }
  toggleModal = () => {
    this.setState({ modalOpen: !this.state.modalOpen })
  }
  toggleResultsDrawer() {
    console.log('Toggled')
  }
  checkForSubmit = ({ charCode }) => {
    if (charCode === 13) {
      this.search()
    }
  }
  filter = e => {
    this.setState({ filter: e.target.value })
  }
  onFilterKeyUp = ({ keyCode }) => {
    if (keyCode === 27) {
      this.setState({ modalOpen: false })
      this.searchRef.current.focus()
    }
  }
  selectResult = result => {
    // console.log(result);
    this.props.onChange({ ...this.props.value, SELECTED: result, CRA_ID: result.SOURCE_ID }, {})
    this.toggleModal()
  }
  deSelect = () => {
    this.props.onChange(
      { ...this.props.value, SELECTED: null, CRA_ID: '0', STATE: this.props.defaultState },
      {}
    )
  }
  openAgentModal = () => {
    this.props.onChange(this.props.value, {}, { addingAgent: true })
    this.agentModal.open()
  }
  setGlobalModalFlagOff = () => {
    this.props.onChange(this.props.value, {}, { addingAgent: false })
    // this.clearNewAgent()
  }
  setNewAgentResult = () => {
    this.props.onChange({ ...this.props.value, 
      NEW: true,
      ORGANIZATION: (this.props.value.INDIVIDUAL_YN == 'y') ? null : this.props.value.ORGANIZATION,
      FIRST_NAME: (this.props.value.INDIVIDUAL_YN == 'y') ? this.props.value.FIRST_NAME : "", 
      MIDDLE_NAME: (this.props.value.INDIVIDUAL_YN == 'y') ? this.props.value.MIDDLE_NAME : "",
      LAST_NAME: (this.props.value.INDIVIDUAL_YN == 'y') ? this.props.value.LAST_NAME : ""
    }, {}, { selected: null })
  }
  clearNewAgent = () => {
    this.props.onChange({
      ...this.props.value,
      NEW: false,
      INDIVIDUAL_YN: 'y',
      FIRST_NAME: '',
      MIDDLE_NAME: '',
      LAST_NAME: '',
      SUFFIX: '',
      ORGANIZATION: '',
      ...getAddressObject(),
      STATE: this.props.value.STATE,
      MAIL_ADDR: resolveAgentMailingAddress(this.props.value)
    })
  }
  render() {
    const {
      value,
      required,
      disabled,
      showMailingAddress,
      searchPlaceholder,
      metadata,
      fieldId,
      errorMessage,
      description,
      sectionLabel,
      agentType1Label,
      agentType2Label,
      tooltip,
      modalOrgLabel,
      modalShowSuffix,
      typeSelectionDisabled
    } = this.props
    return (
      <div className="block-wrapper registered-agent-search">
        {!value.SELECTED && !value.NEW ? (
          <div className="row">
            <div className="col-12">
              <div className={`sub-section ${required ? 'required' : ''}`}>
                <h3>
                  {sectionLabel || 'Search for registered agent'}
                  {tooltip && <FieldTooltip tooltip={tooltip} />}
                </h3>
                {description && <p className="description">{description}</p>}
                {!typeSelectionDisabled && (
                  <DumbField label="Select an agent type" className="reg-type">
                    <RadioInput
                      label="Select an agent type"
                      onChange={this.onChange}
                      name="TYPE_ID"
                      options={[
                        { value: '461', label: agentType1Label || 'Commercial' },
                        {
                          value: '460',
                          label: RA_NONCOMMERCIAL_LABEL || agentType2Label || 'Noncommercial'
                        }
                      ]}
                      fieldId="TYPE_ID"
                      value={value.TYPE_ID.toString()}
                      disabled={disabled}
                      leftAlign={true}
                      ref={focusTarget => {
                        this.focusTarget = focusTarget
                      }}
                    />
                  </DumbField>
                )}
                {value.TYPE_ID && (
                  <div className="row">
                    <div className="col-lg-8 col-md-9 col-sm-10 col-xs-12 search-column">
                      <DumbField label="Name of individual or organization" fieldId={`cra-search-${fieldId}`}>
                        <SearchControl
                          fieldId={`cra-search-${fieldId}`}
                          name="ORGANIZATION"
                          placeholder={searchPlaceholder}
                          additionalParameters={{
                            INCLUDE_CRA_0_YN: 'N',
                            INCLUDE_CRA_1_YN: 'N',
                            TYPE_ID: value.TYPE_ID
                          }}
                          searchType="ACTIVE_CRAS"
                          onChange={this.selectResult}
                          modalTitle="Select a Registered Agent"
                          value={value.SELECTED}
                          width="100%"
                        />
                      </DumbField>
                    </div>
                  </div>
                )}
                {(value.TYPE_ID === '460' || value.TYPE_ID === 460 || typeSelectionDisabled) && (
                  <div className="row">
                    <div className="col-12 new-col">
                      <span>or </span>
                      <button
                        type="button"
                        className="btn btn-medium-neutral add"
                        onClick={this.openAgentModal}
                        disabled={disabled}
                      >
                        <PlusIcon /> Add New Agent
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : null}
        {value.TYPE_ID.toString() === '460' && !value.SELECTED && !this.state.loading ? (
          <div className="block-wrapper" />
        ) : (
          value.SELECTED && (
            <div className="row">
              <div className="col-md-8 col-lg-7">
                <Result
                  className={`static static-selected-result animated ${
                    !disabled ? 'fadeInUp' : ''
                  } fast-animation`}
                  data={value.SELECTED}
                >
                  {!disabled && (
                    <button
                      type="button"
                      className="close"
                      onClick={this.deSelect}
                      ref={focusTarget => {
                        this.focusTarget = focusTarget
                      }}
                    >
                      <span className="icon icon-close" />
                    </button>
                  )}
                </Result>
              </div>
            </div>
          )
        )}
        {value.NEW && (
          <div className="row">
            <div className="col-md-8 col-lg-7">
              <Result
                className={`static static-selected-result animated ${
                  !disabled ? 'fadeInUp' : ''
                } fast-animation`}
                data={{
                  HEADER1:
                    value.INDIVIDUAL_YN === 'y'
                      ? `${value.FIRST_NAME} ${value.MIDDLE_NAME ? `${value.MIDDLE_NAME} ` : ''}${value.LAST_NAME}`
                      : value.ORGANIZATION.HEADER1,
                  HEADER2: 'Registered Agent',
                  SECTIONS: [
                    ...(process.env.RA_EMAIL
                      ? [
                          {
                            label: 'Email',
                            lines: [
                              {
                                line: value.EMAIL
                              }
                            ]
                          }
                        ]
                      : []),
                    ...(process.env.RA_WEBSITE && value.WEBSITE
                      ? [
                          {
                            label: 'Website',
                            lines: [
                              {
                                line: value.WEBSITE
                              }
                            ]
                          }
                        ]
                      : []),
                    {
                      label: RA_ADDRESS_LABEL || 'Physical Address',
                      lines: [
                        {
                          line: <FormattedAddress value={value} />
                        }
                      ]
                    },
                    ...(showMailingAddress
                      ? [
                          {
                            label: 'Mailing Address',
                            lines: [
                              {
                                line: <FormattedAddress value={value.MAIL_ADDR} />
                              }
                            ]
                          }
                        ]
                      : [])
                  ]
                }}
              >
                {!disabled && (
                  <button
                    type="button"
                    className="close"
                    onClick={this.clearNewAgent}
                    ref={focusTarget => {
                      this.focusTarget = focusTarget
                    }}
                  >
                    <span className="icon icon-close" />
                  </button>
                )}
              </Result>
            </div>
          </div>
        )}
        <AddAgentModal
          modalOrgLabel={modalOrgLabel}
          modalShowSuffix={modalShowSuffix}
          value={value}
          metadata={metadata}
          showMailingAddress={showMailingAddress}
          fieldId={fieldId}
          onFieldChange={this.onChange}
          onPrimaryAddressChange={this.setAddressValue}
          onMailingAddressChange={this.setMailAddressValue}
          errorMessage={errorMessage}
          onSave={this.setNewAgentResult}
          onClose={this.setGlobalModalFlagOff}
          onCancel={this.clearNewAgent}
          // onRequestClose={this.closeAgentModal}
          parentProps={this.props}
          ref={ref => {
            this.agentModal = ref
          }}
        />
      </div>
    )
  }
}

class AddAgentModal extends Component {
  state = {
    open: false
  }
  open = () => this.setState({ open: true })
  close = () => {
    this.setState({ open: false })
    this.props.onClose()
  }
  save = () => {
    validateFieldArray(buildFieldIdList([this.props.fieldId]), isValid => {
      if (isValid) {
        this.modal.closeModal()
        this.props.onSave()
      }
    })
  }
  removeErrorDuplicates = () => {
    const { errorMessage } = this.props
    const hashTable = errorMessage.reduce((obj, e) => ({ ...obj, [e]: true }), {})
    return Object.keys(hashTable)
  }
  render() {
    const {
      value,
      modalOrgLabel,
      modalShowSuffix,
      showMailingAddress,
      metadata,
      fieldId,
      parentProps,
      onFieldChange,
      onPrimaryAddressChange,
      onMailingAddressChange,
      searchPlaceholder,
      errorMessage
    } = this.props
    return (
      <Portal isOpened={this.state.open}>
        <Modal
          title="Add New Agent"
          closeModal={this.close}
          cancel={this.props.onCancel}
          modalSize="medium"
          modalBodyClassName="wizard relative-modal"
          saveAndCloseButton={false}
          cancelButton
          // closeButton
          ref={ref => {
            this.modal = ref
          }}
        >
          <div className="template sub-section registered-agent-modal">
            <DumbField validityClass={parentProps.validityClass} label="This Agent is an: ">
              <RadioInput
                onChange={onFieldChange}
                name="INDIVIDUAL_YN"
                fieldId="INDIVIDUAL_YN"
                options={[
                  { value: 'y', label: 'Individual' },
                  { value: 'n', label: modalOrgLabel || 'Organization' }
                ]}
                value={value.INDIVIDUAL_YN}
                leftAlign={true}
              />
            </DumbField>
            {value.INDIVIDUAL_YN === 'y' ? (
              <div className="row">
                <div className="col-sm-4">
                  <DumbField label="First Name" required>
                    <TextInput
                      autoComplete="given-name"
                      validityClass={parentProps.validityClass}
                      value={value.FIRST_NAME}
                      name="FIRST_NAME"
                      onChange={onFieldChange}
                      onBlur={noop}
                      width="100%"
                    />
                  </DumbField>
                </div>
                <div className="col-sm-3 col-md-2">
                  <DumbField label="Middle/Initial">
                    <TextInput
                      autoComplete="additional-name"
                      value={value.MIDDLE_NAME}
                      name="MIDDLE_NAME"
                      onChange={onFieldChange}
                      onBlur={noop}
                      width="100%"
                    />
                  </DumbField>
                </div>
                <div className="col-sm-4 col-md-4">
                  <DumbField label="Last Name" required>
                    <TextInput
                      autoComplete="family-name"
                      validityClass={parentProps.validityClass}
                      value={value.LAST_NAME}
                      name="LAST_NAME"
                      onChange={onFieldChange}
                      onBlur={noop}
                      width="100%"
                    />
                  </DumbField>
                </div>
                {modalShowSuffix && (
                  <div className="col-sm-2 col-md-2">
                    <DumbField label="Suffix">
                      <TextInput
                        autoComplete="honorific-suffix"
                        value={value.SUFFIX}
                        name="SUFFIX"
                        onChange={onFieldChange}
                        onBlur={noop}
                        width="100%"
                      />
                    </DumbField>
                  </div>
                )}
              </div>
            ) : (
              <div className="row">
                <div className="col-sm-11 col-md-10 col-lg-9">
                  <DumbField label="Organization" required>
                    <SearchControl
                      validityClass={parentProps.validityClass}
                      name="ORGANIZATION"
                      searchType="ACTIVE_FILINGS|CRA"
                      metadata={metadata}
                      onChange={onFieldChange}
                      modalTitle="Search Valid Organizations"
                      value={value.ORGANIZATION}
                      placeholder={searchPlaceholder}
                      width="100%"
                    />
                  </DumbField>
                </div>
              </div>
            )}
            {process.env.RA_EMAIL && (
              <div className="row">
                <div className="col-md-7 col-lg-5">
                  <DumbField label="Email" required>
                    <TextInput
                      validityClass={parentProps.validityClass}
                      value={value.EMAIL}
                      name="EMAIL"
                      onChange={onFieldChange}
                      onBlur={noop}
                      width="100%"
                    />
                  </DumbField>
                </div>
              </div>
            )}
            {process.env.RA_WEBSITE && (
              <div className="row">
                <div className="col-md-7 col-lg-5">
                  <DumbField label="Website">
                    <TextInput
                      value={value.WEBSITE}
                      name="WEBSITE"
                      onChange={onFieldChange}
                      onBlur={noop}
                      width="100%"
                    />
                  </DumbField>
                </div>
              </div>
            )}
            <DumbField
              className="cra-address"
              label={RA_ADDRESS_LABEL ? `${RA_ADDRESS_LABEL}:` : 'Physical Address:'}
            >
              <AddressBlock
                {...parentProps}
                singleColSize="col-sm-11 col-md-10 col-lg-9"
                triColSizes={{
                  CITY: 'col-sm-5 col-md-4 col-lg-3',
                  STATE: 'col-sm-3 col-md-3 col-lg-3',
                  POSTAL_CODE: '"col-sm-3 col-md-3 col-lg-3"'
                }}
                isFirst={false}
                fieldId={`${fieldId}_PRIMARY`}
                disableState={
                  process.env.RA_PRINCIPLE_STATE_DISABLED !== undefined
                    ? process.env.RA_PRINCIPLE_STATE_DISABLED
                    : parentProps.disableState
                }
                value={{
                  ADDR1: value.ADDR1,
                  ADDR2: value.ADDR2,
                  ADDR3: value.ADDR3,
                  CITY: value.CITY,
                  STATE: value.STATE,
                  COUNTY: value.COUNTY,
                  COUNTRY: value.COUNTRY,
                  POSTAL_CODE: value.POSTAL_CODE
                }}
                onChange={onPrimaryAddressChange}
              />
            </DumbField>
            {showMailingAddress ? (
              <DumbField className="cra-address" label="Mailing Address:">
                <AddressBlock
                  {...parentProps}
                  singleColSize="col-sm-11 col-md-10 col-lg-9"
                  triColSizes={{
                    CITY: 'col-sm-5 col-md-4 col-lg-3',
                    STATE: 'col-sm-3 col-md-3 col-lg-3',
                    POSTAL_CODE: '"col-sm-3 col-md-3 col-lg-3"'
                  }}
                  isFirst={false}
                  fieldId={`${fieldId}_MAIL`}
                  required={true}
                  disableState={
                    process.env.RA_MAILING_STATE_DISABLED !== undefined
                      ? process.env.RA_MAILING_STATE_DISABLED
                      : parentProps.disableMailingState
                  }
                  value={{
                    ADDR1: value.MAIL_ADDR.ADDR1,
                    ADDR2: value.MAIL_ADDR.ADDR2,
                    ADDR3: value.MAIL_ADDR.ADDR3,
                    CITY: value.MAIL_ADDR.CITY,
                    STATE: value.MAIL_ADDR.STATE,
                    COUNTY: value.MAIL_ADDR.COUNTY,
                    COUNTRY: value.MAIL_ADDR.COUNTRY,
                    POSTAL_CODE: value.MAIL_ADDR.POSTAL_CODE
                  }}
                  onChange={onMailingAddressChange}
                />
              </DumbField>
            ) : null}
            {errorMessage &&
              this.removeErrorDuplicates().map((e, i) => (
                <p className="field-error animated fadeIn fast-animation standalone-error" key={i}>
                  {e}
                </p>
              ))}
            <div className="controls">
              <button type="button" className="btn btn-raised btn-primary" onClick={this.save}>
                Save
              </button>
            </div>
          </div>
        </Modal>
      </Portal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Wizard2/fieldComponents/RegisteredAgentSearch.js